import React from 'react'

const Home = () => {
  return (
    <home className='center'>
      <section className="home" id="home">
      <div className="max-width">
          <div className="row">
            <div className="home-content">
                <div className="text-1">Hello, I am</div>
                <div className="text-2">Indra Pal Singh</div>
                <div className="text-3">And I'm a <span className="typing">Doctor</span></div>
            </div>
          </div>
      </div>
    </section>
    </home>
  )
}

export default Home
